import { Button, TextInput } from '~/components';
import { styled } from '~/modules';

export const Input = styled(TextInput)``;

export const ButtonComponent = styled(Button)`
  width: 100%;
  margin: auto;
`;
